import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Footer from "../components/Footer/Footer";

import axios from "axios";

const Dashboard = () => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  let email = searchParams.get("email");
  let id = searchParams.get("id");
  const [views, setViews] = useState("Loading...");
  const [clicks, setClicks] = useState("Loading...");
  const [title, setTitle] = useState("");
  const [artist, setArtist] = useState("");
  const [image, setImage] = useState("");
  const [votes, setVotes] = useState("Loading...");

  const handleSubmit = (event) => {
    console.log(event);
  };

  const getStats = (email, id) => {
    try {
      axios
        .get(
          `${process.env.REACT_APP_BACKEND_API_SERVER}/getstats?email=${email}&id=${id}`
        )
        .then(
          (response) => {
            setViews(response.data.views);
            setClicks(response.data.clicks);
            setTitle(response.data.title);
            setArtist(response.data.artist);
            setImage(response.data.image);
            setVotes(response.data.votes);
          },
          (error) => {
            console.log(error);
          }
        );
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (email) {
      getStats(email, id);
    }
  }, []);

  if (!email)
    return (
      <>
        <div className="App">
          <div className="w-full text-center px-3">
            <div className="flex justify-center text-center">
              <h1 className="uppercase font-semibold text-white lg:text-4xl md:text-xl text-lg w-full">
                Song Performance
              </h1>
            </div>
            <div className="flex text-center justify-center">
              <p className="text-white lg:text-lg md:text-md text-sm mt-8 lg:w-1/3 w-full">
                Enter your email & the spotify link of the song you entered in a
                contest to see how your song performed: including total votes,
                and more coming soon! Send us any suggestions via IG!
              </p>
            </div>
            <div className="flex w-full justify-center items-center content-center">
              <form
                onSubmit={handleSubmit}
                enctype="multipart/form-data"
                accept-charset="UTF-8"
              >
                <div className="flex space-x-2 justify-center mt-8">
                  <input
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    className="bg-black inline-block border-2 border-indigo-600 px-6 py-2 text-white font-medium lg:text-lg md:text-md text-sm rounded-md"
                  />
                </div>
                <div className="flex space-x-2 justify-center mt-5 mb-8">
                  <input
                    type="url"
                    name="id"
                    placeholder="Enter Spotify link"
                    className="bg-black inline-block border-2 border-indigo-600 px-6 py-2 text-white font-medium lg:text-lg md:text-md text-sm rounded-md"
                  />
                </div>
                <div className="flex space-x-2 justify-center mt-8">
                  <button
                    type="submit"
                    className="inline-block px-6 py-2 bg-indigo-600 text-white font-semibold lg:text-lg md:text-md text-sm rounded-md hover:bg-indigo-600 cursor-pointer"
                  >
                    See My Song
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );

  if (title == null) {
    return (
      <>
        <div className="App">
          <div className="justify-center items-center content-center">
            <h1 className="uppercase font-semibold text-white text-lg">
              404: No Data Found
            </h1>
          </div>
        </div>
        <Footer />
      </>
    );
  } else {
    return (
      <>
        <div className="App">
          <div className="c-player--details">
            <div className="details-img">
              <img src={image} alt="" />{" "}
              {/* "https://source.unsplash.com/random/500x500?music" */}
            </div>
            <h3 className="details-title">
              {title} - {artist}
            </h3>
            {/* Vote */}
            <div className="flex space-x-2 justify-center mt-6">
              <button
                type="button"
                className="inline-block border-2 px-6 py-2 border-indigo-600 text-white font-medium hover:font-semibold lg:text-lg md:text-md text-sm rounded-md hover:bg-indigo-600 cursor-pointer"
              >
                Total Votes: {votes == null ? "N/A" : votes}
              </button>
            </div>
            {/* View */}
            <div className="flex space-x-2 justify-center mt-6">
              <button
                type="button"
                className="inline-block border-2 px-6 py-2 border-indigo-600 text-white font-medium hover:font-semibold lg:text-lg md:text-md text-sm rounded-md hover:bg-indigo-600 cursor-pointer"
              >
                Views (Ads): {views == null ? "N/A" : views}
              </button>
            </div>
            {/* Click */}
            <div className="flex space-x-2 justify-center mt-6">
              <button
                type="button"
                className="inline-block border-2 px-6 py-2 border-indigo-600 text-white font-medium hover:font-semibold lg:text-lg md:text-md text-sm rounded-md hover:bg-indigo-600 cursor-pointer"
              >
                Clicks (Ads): {clicks == null ? "N/A" : clicks}
              </button>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
};

export default Dashboard;
